<style scoped>
    .spinner {
        display: block;
        background-position-y: 150px;
    }
</style>
<template>
    <div class="fields-mapping">
        <div class="tfs4jira-mapping-container">
            <fields-mapping-selects></fields-mapping-selects>
            <div class="tfs4jira-mapping-no-mapped-values-container" v-show="(mappingsGroups != undefined && mappingsGroups.length === 0)">
                <span class="tfs4jira-mapping-no-mapped-values">
                    Please select Jira and TFS fields that you want to map.
                </span>
            </div>
            <table class="tfs4jira-mapping-table">
                <fields-mapping-row :is-wizard-view="isWizardView" v-for="(group,index) in mappingsGroups" :group="group" :key="index" :guid="profileGuid" :groupLength="group.mappings.length"></fields-mapping-row>
            </table>
        </div>
        <div class="spinner" v-show="isLoaderVisible"></div>
    </div>
</template>
<script>
    import FieldsMappingSelects from './FieldsMappingSelects';
    import FieldsMappingRow from './FieldsMappingRow';
    import { mapGetters, mapActions } from 'vuex';
    import { NAMESPACE as FIELDS_MAPPING_NAMESPACE } from '../store/modules/fieldsMapping.js';
    import { NAMESPACE as APP_NAMESPACE } from '../store/modules/app.js';

    export default {
        components: {
            FieldsMappingSelects,
            FieldsMappingRow
        },
        props: ['profileGuid', 'loadOnInit', 'isWizardView'],
        data() {
            return {
                mountCallback: function() {} // its for unit tests purposes
            }
        },
        computed: mapGetters({
            selectedJiraField: FIELDS_MAPPING_NAMESPACE.getters.SELECTED_JIRA_FIELD,
            selectedTfsField: FIELDS_MAPPING_NAMESPACE.getters.SELECTED_TFS_FIELD,
            mappingsGroups: FIELDS_MAPPING_NAMESPACE.getters.MAPPINGS_GROUPS,
            isLoaderVisible: FIELDS_MAPPING_NAMESPACE.getters.IS_LOADER_VISIBLE,
        }),
        mounted: function() {
            this.setUpService({
                prefix: this.contextPath() + '/api/profiles/' + this.profileGuid
            });
            if (this.loadOnInit && this.loadOnInit === 'true' && !this.isWizardView) {
                this.initComponent();
            }
            this.registerListener({
                on: 'RefreshFieldsMappingComponent',
                handler: function(notification) {
                    this.initComponent();
                }.bind(this)
            });
        },
        methods: {
            ...mapActions({
                setUpService: FIELDS_MAPPING_NAMESPACE.actions.SET_UP_SERVICE,
                getAvailableValues: FIELDS_MAPPING_NAMESPACE.actions.GET_AVAILABLE_VALUES,
                registerListener: APP_NAMESPACE.actions.ADD_LISTENER
            }),
            ...mapGetters({
                contextPath: APP_NAMESPACE.getters.CONTEXT_PATH
            }),
            initComponent: async function() {
                await this.getAvailableValues();
                this.mountCallback();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/FieldsMapping.vue